import React from "react";
import CartContainer from "../../components/Cart/CartContainer";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer";

const Cart = () => {
  return (
    <>
      <Navbar />
      <CartContainer />
      <Footer />
    </>
  );
};

export default Cart;
